<template>
  <div>
      <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>basic data</el-breadcrumb-item>
      <el-breadcrumb-item>engineer</el-breadcrumb-item>
    </el-breadcrumb>
 <!-- 卡片视图区域 -->
 <el-card>
  <!-- 搜索与添加区域 -->
  <collapse @getDataList="getDataList" :button-text="'search'">
        <collapse-item>
           <span class="Agent">Agent:</span> 
          <el-input placeholder="Agent" v-model="queryInfoparams.params.agent" clearable></el-input>
        </collapse-item>
        <collapse-item>
        <span class="PlumberCompany">Plumber Company:</span> 
            <el-input placeholder="companyName" v-model="queryInfoparams.params.company" clearable></el-input>      
        </collapse-item>
        <collapse-item>
         <span class="Name">Name:</span> 
          <el-input placeholder="Name" v-model="queryInfoparams.params.name" clearable></el-input>        
        </collapse-item>
        <collapse-item>
         <span class="Phone">Phone:</span> 
            <el-input placeholder="Phone" v-model="queryInfoparams.params.phone" clearable></el-input>     
        </collapse-item> 
        <collapse-item>
         <span class="email">email:</span> 
          <el-input placeholder="email" v-model="queryInfoparams.params.email" clearable></el-input>        
        </collapse-item>
   </collapse>
   <el-row type="flex" justify="end">
               <el-col class="searchBtns" :span="6">
                <el-button-group>
                 <el-button plain size="small" icon="el-icon-plus" @click="addEditDialog" v-hasPermission="['engineer:add']">add</el-button> 
                 <el-button plain size="small" icon="el-icon-share" @click="exportData" v-hasPermission="['engineer:export']">Export</el-button>
                 <el-button plain size="small" icon="el-icon-delete"  @click="reset" v-hasPermission="['engineer:reset']">reset</el-button>                 
                </el-button-group>
               </el-col>
   </el-row> 
  <el-table :data="dataList" border stripe @selection-change="handleSelectionChange" @sort-change="sortChange">
   <el-table-column type="selection" width="55"></el-table-column>
   <el-table-column type="index" label="#"></el-table-column>
   <!-- <el-table-column label="Account" sortable prop="loginAccount" width="160px"></el-table-column> -->
   <el-table-column label="Agent" sortable prop="agencyName" width="160px"></el-table-column>
   <el-table-column label="Plumbing Company" sortable prop="companyName" width="200px"></el-table-column>
   <el-table-column label="Name" sortable prop="userName" width="160px"></el-table-column>
   <el-table-column label="Contact number" sortable prop="mobileNumber" width="160px"></el-table-column>
   <el-table-column label="Email-Address" sortable prop="email" width="160px"></el-table-column>
   <el-table-column label="Source" sortable prop="source" width="160px"></el-table-column>
   <el-table-column label="Status" sortable prop="status" width="160px">
           <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='0'" >Enabled</el-tag>
            <el-tag v-else-if="scope.row.status==='1'" >Disabled</el-tag>
      </template>
   </el-table-column>
   <el-table-column label="Apply time" sortable prop="createdTime" width="160px"></el-table-column>
   <el-table-column label="Tests done last week" sortable prop="testingWeek" width="200px"></el-table-column>
   <el-table-column label="Tests done last month" sortable prop="testingMonth" width="200px"></el-table-column>
   
   <el-table-column label="operate" width="300px" fixed="right">

 <!-- 按钮 -->
        <template slot-scope="scope">
           <div class="btnContainer">
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="showEditDialog(scope.row.id)" v-hasPermission="['engineer:edit']">edit</el-link> 
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="enableEngineer(scope.row.id,scope.row.userId)" v-hasPermission="['engineer:updateStatus']">enable</el-link> 
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="suspendEngineer(scope.row.id,scope.row.userId)" v-hasPermission="['engineer:updateStatus']">suspend</el-link>
            </div>
        </template>
   </el-table-column>
  </el-table>
    <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
 </el-card> 

   <!-- 添加用户的对话框 -->
    <el-dialog title="Please Enter" :visible="addDialogVisible" width="50%" @close="addDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px" >
        <el-row>
           <el-input id="displayInput" v-model="addForm.agencyId"></el-input>
          <el-col :span="12">

               <el-form-item class="left" label="Agent" prop="agencyName" label-width="160px">
                <el-input v-model="addForm.agencyName" disabled></el-input>
               </el-form-item>
          </el-col>

           <el-col :span="12">
               <el-form-item  label="Email-address" prop="email"  label-width="160px">
                  <el-input placeholder=" enter the email" v-model="addForm.email"></el-input>
               </el-form-item>
           </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item class="companyName"  label-position="left" label="Company Name" prop="companyName" label-width="160px">
                  <el-input  v-model="addForm.companyName" disabled></el-input>
              </el-form-item>
             </el-col>
              <el-col :span="12">             
                <el-form-item label="Contact Number" prop="mobileNumber" label-width="160px">
                  <el-input  placeholder=" enter the number" v-model="addForm.mobileNumber"></el-input>
                </el-form-item>
            </el-col>  

        </el-row>
        <el-row>
           <el-col :span="12">
                <el-form-item class="left" label="firstName" prop="firstName" label-width="160px">
                    <el-input placeholder=" enter the first name" v-model="addForm.firstName"></el-input>
                 </el-form-item>
            </el-col>
            <el-col :span="12">
                 <el-form-item class="left" label="lastName" prop="lastName" label-width="160px">
                    <el-input  placeholder=" enter the surname" v-model="addForm.lastName"></el-input>
                 </el-form-item>
            </el-col>
        </el-row>
       <el-row>
         <el-col :span="12">
             
                  <el-form-item label="Area" prop="areaList" label-width="160px">
                  <el-cascader
                  placeholder=" select area"
                  filterable
                  style="width:100%"
                  clearable
                  size="medium"
                  v-model="areaList"
                  :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
                  :options="areaTreeList"
                  ref="treeArea"
                  ></el-cascader>
                  </el-form-item>
                  </el-col> 
          <el-col :span="12">             
                 <el-form-item label="Detail Address" prop="city" label-width="160px">
                    <el-input  placeholder=" enter the address" v-model="addForm.address"></el-input>
                  </el-form-item>
          </el-col>  
        </el-row>
       <el-row>
           <el-col :span="12">
             <el-form-item class="left" label="Post Code" prop="postCode" label-width="160px">
               <el-input placeholder=" enter the post code" v-model="addForm.postCode"></el-input>
             </el-form-item>
            </el-col>
       </el-row>
      </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="addEngineerInfo(userId,companyId)">Save</el-button>
      </span>
    </el-dialog>
    <!-- 修改用户的对话框  此处可与添加用户 优化合并为一个对话框-->
    <el-dialog title="Edit Plumber" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="70px" >
        <el-row>
           <el-input id="displayInput" v-model="addForm.agencyId"></el-input>
          <el-col :span="12">
            <el-form-item class="left" label="Agent" prop="agencyName" label-width="160px">
             <el-input v-model="addForm.agencyName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item  label="Email-address" prop="email" label-width="160px">
               <el-input placeholder=" enter the email" v-model="addForm.email"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item class="companyName"  label-position="left" label="Company Name" prop="companyName" label-width="160px">
                  <el-input v-model="addForm.companyName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">           
                <el-form-item label="Contact Number" prop="mobileNumber" label-width="160px">
                 <el-input placeholder=" enter the number" v-model="addForm.mobileNumber"></el-input>
                </el-form-item>
            </el-col> 
        </el-row>
        <el-row>
           <el-col :span="12">
                <el-form-item class="left" label="firstName" prop="firstName" label-width="160px">
                    <el-input placeholder=" enter the first name" v-model="addForm.firstName"></el-input>
                 </el-form-item>
            </el-col>
           <el-col :span="12">
                <el-form-item class="left" label="lastName" prop="lastName" label-width="160px">
                     <el-input  placeholder=" enter the last name" v-model="addForm.lastName"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
       <el-row>
       <el-col :span="12">
        <el-form-item label="Area" prop="areaList" label-width="160px">
            <el-cascader
            filterable
            placeholder=" select area"
            style="width:100%"
            clearable
            size="medium"
            v-model="areaList"
            :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
            :options="areaTreeList"
            ref="treeArea"
             ></el-cascader>
             </el-form-item>
            </el-col> 
            <el-col :span="12">
              <el-form-item label="Detail address" prop="city" label-width="160px">
               <el-input placeholder=" enter the address" v-model="addForm.address"></el-input>
                </el-form-item>
       </el-col>            
       </el-row>
       <el-row>
           <el-col :span="12">
             <el-form-item class="left" label="Post Code" prop="postCode" label-width="160px">
               <el-input placeholder=" enter the post code" v-model="addForm.postCode"></el-input>
             </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="editEngineerInfo">Save</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import db from '@/services/localstorage';
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
export default {
    components:{Collapse,CollapseItem},
    data() {
       // 验证邮箱的规则
    var checkEmail = (rule, value, cb) => {
      // 验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9])+/
      if (regEmail.test(value)) {
        return cb()
      }
      cb(new Error('please enter a valid email'))
    }
      return {
        pickerOptions: {
          shortcuts: [{
            text: 'last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'last three month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        options: [
          {
          value: '',
          label: ''
        },{
          value: '9',
          label: 'all'
        }, {
          value: '1',
          label: 'used'
        }, {
          value: '0',
          label: 'unused'
        }],
        addressOptions: [
          {
          value: '',
          label: ''
        }],
        userId:'',
        value: '',
        queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
        },
        dataList: [],
        multipleSelection: [],
        addForm: {
        agencyName:'',
        email:'',
        companyName:'',
        loginAccount: '',
        firstName:'',
        mobileNumber:'',
        lastName:'',
        postCode:'',
        address:'',
        userId:'',
        source:'',
        companyId:'',
        areaFullpath:'',
        areaList:'',
        },
        userId:'',
        areaList:'',
        // 添加表单的验证规则对象
        addFormRules: {
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: 'First name is required', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Last name is required', trigger: 'blur' },
        ],
         mobileNumber: [
          { required: true, message: 'Contact Number is required', trigger: 'blur' },
        ],
         postCode: [
          { required: true, message: 'Post Code is required', trigger: 'blur' },
        ],
         areaList: [
          { required: true, message: 'Area is required', trigger: 'blur' },
        ],
        },
        total: 0,
        // 控制添加 对话框的显示与隐藏
        addDialogVisible: false,
        // 控制修改用户对话框的显示与隐藏
        editDialogVisible: false,
        editEmailVisible: false,
        visible: this.$route.query.visible,
        companyId:this.$route.query.companyId,
        
        areaTreeList: [],
            // 默认禁止input输入
        isDisabled: true,
      }
    },

    created(){
      
      var user=db.get("user");
      this.userId=user.userId;
      this.addForm.userType=user.userType;
      this.queryInfoparams.params.userType=user.userType;
      console.log("1:"+this.companyId);
      if(""==this.companyId||undefined==this.companyId){
        this.companyId=user.companyId;
        console.log("2:"+this.companyId);
      }
      this.getDataList();
    },
    methods: {
       //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.getDataList()
    },
    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },
        // 获取 查询数据列表
    async getDataList() {
      this.$post('engineer/pageQuery', this.queryInfoparams).then(
          ({ data: res }) => {
            this.dataList = res.records
            this.total = res.total
          }
        )
    },

    //获取区域地址信息
    getAreaTreeList(){
        this.$get(`tree/getTreeByCode/TREE_PROVINCE/Y/false`).then(({ data: res }) => {
          
            this.areaTreeList = res.data
        })
    },
    // 监听对话框的关闭事件
    goBack () {
      this.$router.back()
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.addDialogVisible=false
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮 添加
    addEngineerInfo(userId,companyId) {   
          
       this.addForm.areaList=this.areaList;
       this.$refs.addFormRef.validate(async (valid) => { 
       //this.addForm.source="EMPLOYEE";
       console.log(this.addForm.areaList.join(','))
       this.addForm.userId=userId;
       this.addForm.companyId=companyId;
       this.addForm.areaFullpath = this.areaList.join(',');
       this.addForm.areaList=null;
       if (!valid) return
        const loading = this.$loading({
          lock: true,
          text: 'Saving',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
       this.$post('engineer/addEngineer', JSON.stringify(this.addForm)).then(
          ({ data: res }) => {
              console.log(res)
          if (res.msg !== 'successfully') {
             loading.close()
            return this.$message.error('Add unsuccessfully')
          }
           loading.close()
          // 关闭对话框
          this.addDialogVisible = false
          // 刷新数据列表
          this.getDataList()
          // 提示修改成功
          this.$message.success('Add successfully')
          }
        )})
    },

    
    editEngineerInfo() {
      this.addForm.areaList=this.areaList;
      this.$refs.editFormRef.validate(async (valid) => {
        this.addForm.areaFullpath = this.areaList.join(',');

        this.addForm.areaList=null;

        if (!valid) return
         const loading = this.$loading({
          lock: true,
          text: 'Saving',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        this.$post('engineer/updateEngineer', this.addForm).then(({ data: res }) => {
          if (res.msg !== 'successfully') {
             loading.close()
            return this.$message.error('Update unsuccessfully')
          }
           loading.close()
          // 关闭对话框
          this.editDialogVisible = false
          // 刷新数据列表
          this.getDataList()
          // 提示修改成功
          this.$message.success('Update successfully')
        })
      })
    },
       // 点击按钮 添加
    async exportData() {
       console.log("queryInfoparams:"+this.queryInfoparams.params.userType)
     // addForm.userId=db.get("userId")
     let res = this.$export("engineer/export",JSON.stringify(this.queryInfoparams),"plumber_information")


    },
    
    editDialogClosed() {
      this.editDialogVisible=false
      this.$refs.editFormRef.resetFields()
    },
      // 展示新增的对话框
    async addEditDialog() {
       this.getAreaTreeList();
      this.addDialogVisible = true
      this.$get(`engineer/queryCompanyInfoById/${this.companyId}`).then(({ data: res }) => {
        this.addForm = {
         agencyId:res[0].agencyId,
         companyId:res[0].id,
         agencyName:res[0].agencyName,        
         companyName:res[0].companyName,
        }
        this.areaList=null
        console.log(this.addForm)
      })
    },
      // 展示编辑用户的对话框
    async showEditDialog(id) {
      this.getAreaTreeList();
      this.editDialogVisible = true
      this.$get(`engineer/queryEngineerById/${id}`).then(({ data: res }) => {
        this.addForm = {
         id:id,
         userId:res.userId,  
         companyId:res.companyId,
         agencyName:res.agencyName,
         email:res.email,
         companyName:res.companyName,
         loginAccount:res.loginAccount,
         firstName:res.firstName,
         mobileNumber:res.mobileNumber,
         lastName:res.lastName,
         postCode:res.postCode,
         address:res.address,
         areaList:res.areaList,
        }
        this.areaList=res.areaList
      })
    },

    enableEngineer(id,userId) {
     console.log("msg"+userId)
       this.$get(`engineer/updateEngineerStatus/${id}/${0}/${userId}`).then(({ data: res }) => {
          console.log("msg"+res.msg)
          if (res.msg !== 'successfully') {
            return this.$message.error('Enabled unsuccessfully')
          }
          // 刷新数据列表
          this.getDataList()
          // 提示修改成功
          this.$message.success('Enabled successfully')
        })
    },
    suspendEngineer(id,userId) {
      console.log("msg"+userId)
       this.$get(`engineer/updateEngineerStatus/${id}/${1}/${userId}`).then(({ data: res }) => {
          
          if (res.msg !== 'successfully') {
            return this.$message.error('Disabled unsuccessfully')
          }
          // 刷新数据列表
          this.getDataList()
          // 提示修改成功
          this.$message.success('Disabled successfully')
        })
    },

     setIsSupper() {
       debugger
      if (this.multipleSelection.length == 1){
         this.multipleSelection.forEach((row) => {
          this.$get(`engineer/isSuper/${row.id}/Y`).then(({ data: res }) => {
          
          if (res.msg !== 'successfully') {
            return this.$message.error('Update unsuccessfully')
          }
          // 刷新数据列表
          this.getDataList()
          this.$message.success('Update successfully')
           })
         })
      
      }else{
         return this.$message.error('Please select one')
      }

    },

      setIsNotSupper() {
        debugger
       if (this.multipleSelection.length == 1){
         this.multipleSelection.forEach((row) => {
       this.$get(`engineer/isSuper/${row.id}/N`).then(({ data: res }) => {
          
          if (res.msg !== 'successfully') {
            return this.$message.error('Update unsuccessfully')
          } 
          this.getDataList()
          // 提示修改成功
          this.$message.success('Update successfully')
        })
         })
        }else{
         return this.$message.error('Please select one')
      }
    },

     async reset() {
       this.queryInfoparams.params.agent='';
       this.queryInfoparams.params.company='';
       this.queryInfoparams.params.name='';
       this.queryInfoparams.params.phone='';
       this.queryInfoparams.params.email='';
    },
   }
  }

</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.collapseBtn {
  height: 40px;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

#el-collapse-head-4510{
  height: auto;
}
.el-col{
  display: flex;
}
.el-date-editor{
   height: auto;
   width:auto;
}
.demonstration1{
  height: auto;
  width:25%;
}
.el-button{
     height: auto;
     width:auto;
}
.left{
  width:auto;
}
#el-input__inner{
  width:200px;
}
/deep/#displayInput{
  display: none;
}
</style>